import { render, staticRenderFns } from "./PromotionCodeDetail.vue?vue&type=template&id=109fd96e"
import script from "./PromotionCodeDetail.vue?vue&type=script&lang=ts"
export * from "./PromotionCodeDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports